import React from 'react';
import { Sparkles, X } from 'lucide-react';
interface AIInsightCardProps {
  title: string;
  insights: string[];
  ctaLabel?: string;
  onCtaClick?: () => void;
  dismissible?: boolean;
  onDismiss?: () => void;
  lastUpdated?: string;
}
export const AIInsightCard: React.FC<AIInsightCardProps> = ({
  title,
  insights,
  ctaLabel,
  onCtaClick,
  dismissible = false,
  onDismiss,
  lastUpdated
}) => {
  return <div className="rounded-lg p-3 shadow-sm relative" style={{
    background: 'linear-gradient(135deg, rgba(255, 0, 77, 0.05) 0%, rgba(116, 10, 214, 0.05) 100%)',
    borderLeft: '4px solid',
    borderImage: 'linear-gradient(180deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%) 1'
  }} data-id="element-144">
      {/* Header */}
      <div className="flex items-start justify-between mb-2" data-id="element-145">
        <div className="flex items-center gap-1.5" data-id="element-146">
          <div className="flex items-center gap-1 px-1.5 py-0.5 rounded-full" style={{
          background: 'linear-gradient(90deg, rgba(255, 0, 77, 0.1) 0%, rgba(116, 10, 214, 0.1) 100%)'
        }} data-id="element-147">
            <Sparkles className="h-3 w-3" style={{
            color: '#740AD6'
          }} data-id="element-148" />
            <span className="text-xs font-semibold" style={{
            color: '#740AD6'
          }} data-id="element-149">
              AI
            </span>
          </div>
          <h3 className="text-xs font-semibold text-gray-900" data-id="element-150">{title}</h3>
        </div>
        {dismissible && <button onClick={onDismiss} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-151">
            <X className="h-3.5 w-3.5 text-gray-400" data-id="element-152" />
          </button>}
      </div>

      {/* Insights - Always show all */}
      <div className="space-y-1 mb-2" data-id="element-153">
        {insights.map((insight, index) => <div key={index} className="flex items-start gap-1.5" data-id="element-154">
            <span className="flex-shrink-0 w-1 h-1 rounded-full mt-1.5" style={{
          background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)'
        }} data-id="element-155"></span>
            <p className="text-xs text-gray-700 leading-relaxed" data-id="element-156">{insight}</p>
          </div>)}
      </div>

      {/* CTA - Compact inline with gradient outline */}
      {ctaLabel && onCtaClick && <div className="inline-block" style={{
      background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
      padding: '1px',
      borderRadius: '100px'
    }} data-id="element-157">
          <button onClick={onCtaClick} className="py-1 px-2.5 bg-white text-black font-medium text-xs transition-colors hover:bg-gray-50 whitespace-nowrap" style={{
        borderRadius: '100px'
      }} data-id="element-158">
            {ctaLabel}
          </button>
        </div>}

      {/* Timestamp */}
      {lastUpdated && <p className="text-xs text-gray-400 mt-2 pt-2 border-t border-gray-200" data-id="element-159">
          Aggiornato: {lastUpdated}
        </p>}
    </div>;
};